/** 
 * 
*/
export const ACCESS_TYPES = {
    ACCESS_AREA: 1,
    FLOOR_AREA: 2,
    ACCESS_GROUP: 1,
    FLOOR_GROUP: 2,
}
